import Dashboard from '../containers/dashboard'
import PaymentReviewedDetailsManagement from '../containers/payment-reviewed-details-management'

const PaymentReviewedDetails = () => {
  return (
    <Dashboard>
      <PaymentReviewedDetailsManagement />
    </Dashboard>
  )
}

export default PaymentReviewedDetails
